<template>
    <div>
        <br>
        <h3>Medical Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.medicalLicenseNumber)">
                        <label>Your Medical License Number</label>
                        <input type="text" name="medicalLicenseNumber" class="form-control" required
                               v-model.lazy="state.registrantData.medicalExtraData.medicalLicenseNumber" tabindex="15">
                        <field-messages name="medicalLicenseNumber" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">License number is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.medicalLicenseExpirationDate)">
                        <label>Medical License Number Expiry Date</label>
                        <input type="date" name="medicalLicenseExpirationDate" class="form-control" required
                               v-model.lazy="state.registrantData.medicalExtraData.medicalLicenseExpirationDate" tabindex="17">
                        <field-messages name="medicalLicenseExpirationDate" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Expiry date is a required field</div>
                        </field-messages>
                    </validate>
                </div>
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.numberOfYearsPracticing)">
                        <label>Number of years practicing</label>
                        <input type="text" name="numberOfYearsPracticing" class="form-control" required
                               v-model.lazy="state.registrantData.medicalExtraData.numberOfYearsPracticing" tabindex="16">
                        <field-messages name="numberOfYearsPracticing" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Years practicing is a required field</div>
                        </field-messages>
                    </validate>
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.medicalSpecialty)">
                        <label>Medical Specialty</label>
                        <input type="text" name="medicalSpecialty" class="form-control" required
                               v-model.lazy="state.registrantData.medicalExtraData.medicalSpecialty" tabindex="18">
                        <field-messages name="medicalSpecialty" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">Medical specialty is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
        </vue-form>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'MedicalInfo',
    data: function () {
      return {
        formstate: {},
      }
    },
    computed: {
      ...mapGetters({
        state: 'getState',
      }),

    },
    watch: {
      formstate: function (val) {
        this.state.formstate.medical = val;
      },
    },
    methods: {
      fieldClassName: function (field) {

        if (!field) {
          return ''
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
          return 'has-success'
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
          return 'has-danger'
        }
      },
      onSubmit: function () {
        console.log(this.formstate.$valid)
      }
    },
  }
</script>

<style>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
